import React, { memo } from "react";

import SimulatorComponent from "./simulator";

import { StyledSkeleton } from "./styledSim";
import { TabContentSection } from "../../../../containers/singleSim/styledSimContainer";

const SimTabComponent = ({ simSrc, data, error }) => {
  let element = null;
  if (error) {
    element = error;
  } else if (data) {
    element = (
      <TabContentSection>
        <SimulatorComponent simSrc={simSrc} data={data} />
      </TabContentSection>
    );
  } else {
    element = <StyledSkeleton height={"50vh"} />;
  }
  return element;
};

export default memo(SimTabComponent);
